import { COMMON_AXISLABEL_FORMATTER } from './base';
export var DM_THEME = {
  // 背景色
  DM_BACKGROUND_COLOR: '#DFEFFF',
  // 主题色
  DM_COLOR: ['#637BC0', '#76ABF4', '#5AD2D2', '#67D268', '#C2E45D', '#FFD84E', '#FFAE5E', '#F5906E', '#ED6D6D', '#F590A9', '#B0A2DB', '#948DED'],
  // 趋势图-图例
  DM_LINE_LEGEND: {
    type: 'plain',
    bottom: 15,
    itemStyle: {
      opacity: 0
    },
    itemWidth: 4,
    lineStyle: {
      type: 'solid',
      opacity: 1,
      width: 2,
      cap: 'round'
    },
    textStyle: {
      color: 'rgba(0, 0, 0, 0.9)',
      fontSize: 12,
      padding: [0, 0, 0, 5],
      fontFamily: 'Microsoft YaHei'
    }
  },
  // 常规图例
  DM_COMMON_LEGEND: {
    type: 'plain',
    icon: 'circle',
    bottom: 15,
    itemWidth: 8,
    itemHeight: 8,
    itemGap: 20,
    padding: 0,
    itemStyle: {
      opacity: 1
    },
    textStyle: {
      color: 'rgba(0, 0, 0, 0.9)',
      fontSize: 12,
      padding: [0, 0, 0, 5],
      fontFamily: 'Microsoft YaHei'
    }
  },
  // tooltip
  DM_TOOLTIP: {
    backgroundColor: 'rgba(80, 80, 80, 1)',
    show: true,
    confine: true,
    trigger: 'axis',
    borderWidth: 0,
    borderRadius: 2,
    textStyle: {
      color: 'rgba(255, 255, 255, 100)'
    }
  },
  // 轴文本样式
  DM_AXISLABEL: {
    show: true,
    margin: 12,
    color: 'rgba(153, 153, 153, 100)',
    formatter: COMMON_AXISLABEL_FORMATTER
  },
  // 参考线样式
  DM_SPLITLINE: {
    lineStyle: {
      type: 'solid',
      color: 'rgba(241, 241, 241, 1)'
    }
  },
  // 指示线样式
  DM_AXISPOINTER: {
    type: 'line',
    lineStyle: {
      type: 'solid',
      color: 'rgba(241, 241, 241, 1)'
    },
    z: 0
  }
};